import React, { Fragment, useState } from "react";
import * as actionCreators from "../../Store/actions/index";
// import { connect } from "react-redux";
// import { auth } from "../../Firebase/firebase";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import Authentication from "../../Containers/Authentication/Authentication";
import TopToolBar from "../../Component/Navigation/TopToolBar/TopToolBar";
import classes from "./Layout.module.css";
import smallScernUser from "../../assets/svg/smallScernUser.svg";
import smallScreenHome from "../../assets/svg/smallScreenHome.svg";
import logout from "../../assets/svg/logout.svg";

const Layout = (props) => {
    const [showAuth, setShowAuth] = useState(false);
    const [authMode, setAuthMode] = useState('signIn');
    let history = useHistory();

    const showAuthHandler = (mode, kepShowing) => {
        if (kepShowing) {
            setShowAuth(true)
        } else {
            setShowAuth(!showAuth)
        }
        if (mode === 'signUp') {
            this.setState({
                authMode: 'signUp'
            })
        }
        else if (mode === 'signIn') {
            setAuthMode('signIn')
        }
        else if (mode === 'passwordReset') {
            setAuthMode('passwordReset')
        }
        else if (mode === 'verifyEmail') {
            setAuthMode('verifyEmail')
        }
    }

    return (
        <Fragment>
            {showAuth &&
                <Authentication
                    showAuth={showAuth}
                    showAuthHandler={showAuthHandler}
                    authMode={authMode} />
            }
            <header>
                <TopToolBar />
            </header>
            <main>
                {props.children}
                <div id="footer" className={classes.Tailer}>
                    © 2020 pcari.my Terms & Conditions Privacy
                </div>
            </main>
            <div className={classes.onlySmallScreens}>
                {props.userEmail ?
                    <Fragment>
                        <img src={smallScernUser} alt='users' onClick={() => { history.push('/Profile') }} />
                        <img src={logout} alt='logout' onClick={() => {
                            history.push('/');
                            props.onLogoutAuth()
                        }} />
                    </Fragment>
                    :
                    <Fragment>
                        <img src={smallScreenHome} alt='home' onClick={() => { history.push('/') }} />
                        <img src={smallScernUser} alt='users' onClick={() => { showAuthHandler('signIn') }} />
                    </Fragment>
                }

            </div>
        </Fragment >
    );
}


const mapStateToProps = state => {
    return {
        userEmail: state.Auth.userEmail
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onLogoutAuth: () => { dispatch(actionCreators.logoutAuth()) }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Layout);